// This code was originally forked (and then modified) from `@grafana/data` version `10.4.4`. It only contains the
// subset of code we needed at the time, but you can find the original on GitHub:
// https://github.com/grafana/grafana/tree/v10.4.4/packages/grafana-data/src/dataframe

export interface DataFrame {
  fields: Field[];
  length: number;
}

export const ROW_ID_FIELD_NAME = 'rowId';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export interface Field<T = any> {
  /**
   * Name of the field (column)
   * If the name is "rowId", we will use this field to assign row IDs, and it will be hidden.
   */
  name: string;

  /**
   *  Field value type (string, number, etc)
   */
  type: FieldType;

  /**
   * The raw field values
   */
  values: T[];

  /**
   * Convert a value for display
   */
  display?: (value: unknown) => DisplayValue;
  columnFlex?: number;
}

export enum FieldType {
  time = 'time', // or date
  number = 'number',
  string = 'string',
  boolean = 'boolean',
  trace = 'trace',
  geo = 'geo',
  enum = 'enum',
  other = 'other', // Object, Array, etc
  frame = 'frame', // DataFrame
  nestedFrames = 'nestedFrames',
}

export interface DisplayValue {
  text: string;
  icon: JSX.Element;
}
